import { Source } from 'app/constants/import/source'

export const getSourceName = (
  source: Source,
  translate: (string) => string,
): string => {
  const text: string = Source[source]
  return translate(`source.${text}`)
}
